/**
 * Payments API client — talks to /api/payments/*
 * All requests include credentials so the cookie session flows.
 */
const API = process.env.REACT_APP_BACKEND_URL;

async function call(path, options = {}) {
  const res = await fetch(`${API}/api${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      if (typeof body.detail === 'string') detail = body.detail;
    } catch (e) {
      // non-JSON error response — keep the default `detail` string. Surface at
      // debug-level so failures aren't completely silent during investigation.
      // eslint-disable-next-line no-console
      console.debug("[paymentsApi] non-JSON error body for", path, e);
    }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const paymentsApi = {
  catalogue: () => call('/payments/catalogue'),
  pricePreview: (planId, geographyIds, combinedAuthority, email = null) =>
    call('/payments/price-preview', {
      method: 'POST',
      body: JSON.stringify({
        plan_id: planId,
        geography_ids: geographyIds,
        combined_authority: combinedAuthority || null,
        email: email || undefined,
      }),
    }),
  createOrder: ({ planId, geographyIds, combinedAuthority, subscriberType }) =>
    call('/payments/create-order', {
      method: 'POST',
      body: JSON.stringify({
        plan_id: planId,
        geography_ids: geographyIds,
        combined_authority: combinedAuthority || null,
        subscriber_type: subscriberType,
      }),
    }),
  verifyOrder: (orderId) =>
    call('/payments/verify', {
      method: 'POST',
      body: JSON.stringify({ order_id: orderId }),
    }),
  mySubscription: () => call('/me/subscription'),
  trackIntercept: (feature, payload) =>
    call('/freemium/intercept', {
      method: 'POST',
      body: JSON.stringify({ feature, payload, session_id: getSessionId() }),
    }).catch(() => null),  // analytics — never block UX
};

function getSessionId() {
  try {
    let s = sessionStorage.getItem('infralytics_session_id');
    if (!s) {
      s = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem('infralytics_session_id', s);
    }
    return s;
  } catch {
    return null;
  }
}
